import { useEffect } from "react";
import { RESERVE_STEP_INDEX } from "../config/constants";

const TITLE_MAP = {
  [RESERVE_STEP_INDEX.RESERVE_ITEMS]: "预约维保",
  [RESERVE_STEP_INDEX.TIME_STORE]: "选择门店时间",
  [RESERVE_STEP_INDEX.CONTACT_INFO]: "填写联系信息",
};

export default function useReserveStepDocumentTitle(currentStep: number) {
  useEffect(() => {
    const title = TITLE_MAP[currentStep];
    if (title) {
      document.title = title;
    }
  }, [currentStep]);
}
